module.exports = __webpack_public_path__ + "@/assets/img/14.51ae09a1.jpg";